import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import clarityIcon from '../assets/images/clarity-icon.svg';
import strategyIcon from '../assets/images/strategy-icon.svg';
import confidenceIcon from '../assets/images/confidence-icon.svg';

const Benefits = () => {
  const benefits = [
    {
      icon: clarityIcon,
      title: "Clarity",
      description: "Cut through the noise and confusion around AI. Gain a clear understanding of which AI tools and approaches are right for your specific needs."
    },
    {
      icon: strategyIcon,
      title: "Strategy",
      description: "Develop a comprehensive AI implementation plan aligned with your business goals, ensuring that every AI initiative delivers measurable results."
    },
    {
      icon: confidenceIcon,
      title: "Confidence",
      description: "Move forward with confidence, knowing you have expert guidance to help you navigate challenges, avoid costly mistakes, and maximize ROI."
    }
  ];

  return (
    <BenefitsSection>
      <div className="container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          How You'll Benefit
        </motion.h2>
        <motion.p 
          className="section-intro"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Our coaching service is designed to deliver tangible benefits that transform how you approach and implement AI in only 90 minutes.
        </motion.p>
        
        <BenefitsGrid>
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 * index }}
            >
              <BenefitCard>
                <BenefitIcon>
                  <img src={benefit.icon} alt={benefit.title} />
                </BenefitIcon>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </BenefitCard>
            </motion.div>
          ))}
        </BenefitsGrid>
      </div>
    </BenefitsSection>
  );
};

const BenefitsSection = styled.section`
  background-color: var(--white);
  text-align: center;
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

const BenefitCard = styled.div`
  background-color: #f4f6fc;
  border-radius: 8px;
  padding: 2rem;
  text-align: left;
  transition: var(--transition);
  height: 100%;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow);
  }
  
  h3 {
    font-size: 1.75rem;
    margin-bottom: 1rem;
  }
  
  p {
    font-size: 1.1rem;
  }
  
  @media (max-width: 768px) {
    padding: 1.5rem;
    
    h3 {
      font-size: 1.5rem;
    }
    
    p {
      font-size: 1rem;
    }
  }
`;

const BenefitIcon = styled.div`
  width: 60px;
  height: 60px;
  margin-bottom: 1.5rem;
  
  img {
    width: 100%;
    height: 100%;
  }
`;

export default Benefits;
